<div class="card panel-flat-color primary-panel flex-panel">
    <form [formGroup]="infoForm" (ngSubmit)="onSubmit()">
        <div class="panel-flat-header ws-flex-container-horizontal">
            <h3 class="ws-flex-auto ws-truncate">Info</h3>
            <div class="ws-flex-none header-button-container">
                @if (infoForm.disabled && canEdit) {
                    <button
                        type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        helpTooltip
                        helpContentId="app.edit"
                        [disabled]="!canEnterEditMode"
                        (click)="edit()">
                        <i class="fa fa-pencil fa-align"></i>
                    </button>
                }
                @if (!infoForm.disabled && canEdit) {
                    <button type="submit"
                            class="ace-btn btn-text has-icon btn-primary"
                            helpTooltip
                            helpContentId="app.save"
                            [disabled]="infoForm.pristine || infoForm.invalid">
                        <i class="fa fa-save fa-align"></i>
                    </button>
                }
                @if (!infoForm.disabled && canEdit) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            helpTooltip
                            helpContentId="app.cancel"
                            (click)="cancel()">
                        <i class="fa fa-times fa-align"></i>
                    </button>
                }
                @if (!isExpanded) {
                    <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="expandComponent()">
                        <i class="fa fa-arrows-alt" helpTooltip helpContentId="app.expand"></i>
                    </button>
                }
                @if (isExpanded) {
                    <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="collapseComponent()">
                        <i class="fa fa-compress" helpTooltip helpContentId="app.collapse"></i>
                    </button>
                }
            </div>
        </div>
        <div class="panel-flat-body ws-flex-container-vertical">
            <div class="row">
                <div class="col-lg-6">
                    <div class="mb-3" [class.has-error]="infoForm.controls.name.invalid && infoForm.controls.name.touched">
                        <label>Name</label>
                        <input type="text" formControlName="name" class="form-control" maxlength="50">
                    </div>
                    <div class="mb-3">
                        <label>Default Company Permissions:</label>
                        <select class="form-select form-select-sm" formControlName="defaultPermission">
                            @for (option of permissionOptions; track option) {
                                <option [value]="option">{{ option }}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label>Description</label>
                        <textarea class="form-control" rows="4" formControlName="description" maxlength="100"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="mb-3">
                        <label [title]="isConsultantGroupTitle">
                            <input type="checkbox"
                                   formControlName="isConsultantGroup"
                                   style="margin-right: 5px;">
                            Consultant User Group</label>
                    </div>
                </div>
            </div>
            @if (showDocumentsGroupCheckbox) {
                <div class="row">
                    <div class="col-lg-6">
                        <div class="mb-3">
                            <label>
                                <input type="checkbox"
                                       formControlName="isDocumentsGroup"
                                       style="margin-right: 5px;">
                                Documents User Group</label>
                        </div>
                    </div>
                </div>
            }
            @if (showSupportGroupCheckbox) {
                <div class="row">
                    <div class="col-lg-6">
                        <div class="mb-3">
                            <label>
                                <input type="checkbox"
                                       formControlName="isSupportGroup"
                                       style="margin-right: 5px;">
                                Support User Group</label>
                        </div>
                    </div>
                </div>
            }
        </div>
    </form>
</div>
